import api from './api';

// Main search bar (header + homepage hero): catalogue products are capped, excess inventory is not
export const MAIN_SEARCH_PRODUCT_LIMIT = 5;
const EXCESS_RESULTS_LIMIT = 100;

// Searches the catalogue and excess inventory together. Either side failing just leaves that section empty.
export const fetchMainSearch = async (query) => {
    const [catalogue, excess] = await Promise.allSettled([
        api.smartSearch(`?query=${encodeURIComponent(query)}&limit=15`),
        api.getExcessData({ page: 1, limit: EXCESS_RESULTS_LIMIT, filters: [], search: query }),
    ]);

    const results = (catalogue.status === 'fulfilled' && catalogue.value?.data?.data?.results) || [];
    // Keep categories as they were; only the first few products are shown
    let productsShown = 0;
    const suggestions = results.filter((item) => item?.type !== 'product' || productsShown++ < MAIN_SEARCH_PRODUCT_LIMIT);

    // getExcessStock replies { success, data: [rows], totalItems, ... }
    const rows = excess.status === 'fulfilled' ? excess.value?.data?.data : null;
    const excessItems = Array.isArray(rows) ? rows : rows?.data || [];

    return { suggestions, excessItems };
};

// Excess rows store the uploader's manufacturer; "n/a" means none was given
export const getExcessManufacturer = (item) => {
    const fromCatalogue = item?.productData?.productOverview?.manufacturer?.name;
    if (fromCatalogue) return fromCatalogue;
    const fromStock = item?.manufacturer;
    return fromStock && String(fromStock).toLowerCase() !== 'n/a' ? fromStock : '';
};

export const formatStock = (qty) => `${Number(qty || 0).toLocaleString('en-IN')} in stock`;
